import React, { useEffect } from "react";
import { useField, useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import "./SelectSearch.scss";
import * as select from "tail.select";

import { useTranslation } from "react-i18next";
import SummaryItem from "../components/SummaryItem/SummaryItem";

export default function SelectSearchField(props) {
  const { label, options, onChange, placeholder, validationSchema, ...rest } =
    props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { summaryMode } = rest;
  const { values, setFieldValue } = useFormikContext();
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;

  const fieldRefClass = "select-" + field.name;
  const { t } = useTranslation();
  useEffect(() => {
    const _onChange = (item) => {
      if (onChange) {
        onChange(item.value, values, setFieldValue);
      }
      const wrapper = item?.option?.parentNode?.nextSibling;
      if (wrapper && item.value) {
        wrapper.classList.remove("gcap-tail-select--no-selection");
      } else {
        wrapper.classList.add("gcap-tail-select--no-selection");
      }

      setValue(item.key);
    };
    // eslint-disable-next-line
    if (!summaryMode) {
      let SelectFieldObject = null;
      const actSelect = () => {
        try {
          SelectFieldObject = select("." + fieldRefClass, {
            classNames:
              "gcap-tail-select default gcap-tail-select--no-selection", // For our demonstration only
            descriptions: true,
            placeholder: placeholder,
            locale: localStorage.getItem("i18nextLng").split("-")[0],
            width: "100%",
            search: true,
          });
          if (SelectFieldObject) {
            SelectFieldObject.on("change", _onChange);
          }
        } catch (error) {
          console.log("Cannot rendered field" + fieldRefClass);
        }
      };
      actSelect();
      return () => {
        document.removeEventListener("DOMContentLoaded", actSelect);
      };
    }
    // eslint-disable-next-line
  }, [fieldRefClass, placeholder]);

  return (
    <Form.Group>
      {!summaryMode ? (
        <>
          {label && (
            <Form.Label
              htmlFor={field.name}
              className="paragraph-small-fs9 font-color-1"
            >
              {label}
            </Form.Label>
          )}
          <Form.Control
            as="select"
            className={`gcap-select ${fieldRefClass} ${
              meta.touched && meta.error ? "is-invalid" : ""
            }`}
            {...field}
            value={field.value}
            id={field.name}
            required={isRequired}
          >
            {(options || []).map((option) => {
              let properLabel = option.label;
              let emptyOptionToNotRender = option.label === "" && option.value === "";
              if (
                typeof option.label === "object" &&
                option.label.props &&
                option.label.props.i18nKey
              ) {
                properLabel = t(option.label.props.i18nKey);
              }
              return (
                <option
                  value={option.value}
                  key={field.name + "__" + option.value}
                  disabled={emptyOptionToNotRender}
                  hidden={emptyOptionToNotRender}
                >
                  {properLabel}
                </option>
              );
            })}
          </Form.Control>

          {meta.touched && meta.error && (
            <p
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </p>
          )}
        </>
      ) : summaryMode && !field.value ? (
        <></>
      ) : (
        <>
          {label && (
            <span className="paragraph-small-fs9">
              {label}
            </span>
          )}
          <SummaryItem value={t(field.value)} error={meta.error} />
        </>
      )}
    </Form.Group>
  );
}
